export default "https://cdn-static.gokick.com/assets/bc95401d28f090206b11ed03f14553a528aaf8ef/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";